import { cn } from "@/lib/utils";

const METHOD_STYLES = {
	GET: "bg-[#61affe]/15 text-[#61affe]",
	POST: "bg-[#49cc90]/15 text-[#49cc90]",
	PUT: "bg-[#fca130]/15 text-[#fca130]",
	DELETE: "bg-[#f93e3e]/15 text-[#f93e3e]",
	PATCH: "bg-[#50e3c2]/15 text-[#50e3c2]",
};

const MethodPill = ({ method }) => {
	const upperMethod = method?.toUpperCase() || "GET";
	return (
		<span
			className={cn(
				"inline-block text-[10px] font-bold px-1.5 py-0.5 rounded font-mono min-w-[42px] text-center",
				METHOD_STYLES[upperMethod] || METHOD_STYLES.GET
			)}
		>
			{upperMethod}
		</span>
	);
};

export default MethodPill;
